import styled from '@emotion/styled';
import Image from 'next/image';

const StyledImage = styled(Image)<{ x?: number; y?: number }>`
  object-fit: cover;
  object-position: ${({ x, y }) => (x && y ? `${x}% ${y}%` : '')};
`;

export { StyledImage };
